import { render, staticRenderFns } from "./ScrollDownArrow.vue?vue&type=template&id=0281b770&scoped=true&"
import script from "./ScrollDownArrow.vue?vue&type=script&lang=js&"
export * from "./ScrollDownArrow.vue?vue&type=script&lang=js&"
import style0 from "./ScrollDownArrow.vue?vue&type=style&index=0&id=0281b770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0281b770",
  null
  
)

export default component.exports